import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import {
  Table,
  Select,
  Input,
  message,
  DatePicker,
  Col,
  Row,
  Spin,
} from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { getClientid, getUserInfo, getUserList } from "redux/selectors";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import ViewIncidentLog from "./Viewincidentlog";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const CustomStyle = styled.div`
  .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }
  .total {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .in {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  .inci {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: 0px;
  }
  .search {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: -5px;
  }
  .dropdown-container a:hover {
    color: #1890ff;
  }
  .dropdown-container a .anticon {
    margin-left: 5px;
    font-size: 9px;
  }
  .action-icons {
    display: none;
    gap: 16px;
  }
  .ant-table-tbody > tr:hover .action-icons {
    display: flex;
  }
  .custom-row td {
    height: 70px;
    vertical-align: middle;
  }
  .suspend-text {
    color: #f28916;
  }
  .res-text {
    color: #08c108;
  }
  .adjust-margin {
    margin-top: 10px;
    margin-left: -5px;
  }
  .dis-text {
    color: #ee2738;
  }
  .ant-modal {
    z-index: 9999 !important;
  }
  .ant-modal-body {
    overflow-y: auto;
  }
  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
  }
  .date-range-container {
    display: flex;
  }
  .datepicker-style {
    width: 180px;
    height: 34px;
    border-radius: 24px;
  }
  @media (max-width: 768px) {
    .total {
      display: block !important;
    }
    .search {
      margin-bottom: 10px !important;
      margin-left: 0 !important;
    }
    .action-dropdown {
      margin-bottom: 10px !important;
      margin-left: -12px !important;
    }
  }
`;

// Category values restricted to this specific user (must match
// the `value` field in `incidentTypes` exactly).
const IT_INCIDENT_TYPES = [
  "Asset Breakages",
  "Hardware Issues",
  "Software Issues",
  "System Problems",
  "Application Problems",
  "Equipment Malfunctions",
  "Other Technology-Related Incidents",
];


const RESTRICTED_IT_ONLY_USERNAME = "aodero@fke-kenya.org";

function IncidentLog({ userInfo, ClientId, userList }) {
  const { t } = useTranslation();

  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showLoader, toggleLoader] = useState(false);
  const history = useHistory();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [assetsData, setDisData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
console.log(userInfo ,"userList", userList);  
  const isITOnlyUser =
    userInfo?.userid === RESTRICTED_IT_ONLY_USERNAME;

  const disableToDate = (current) => {
    return fromDate ? current && current.isBefore(fromDate, "day") : false;
  };

  const getDisData = async () => {
    try {
      setLoading(true);
      const { data, code } = await CALL_API(`incident`, "get", {});
      if (code === "SUCCESS" && Array.isArray(data)) {
        setDisData([...data].reverse());
        setFilteredData(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error(t("Failed to fetch data. Please try again."));
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error(t("Something went wrong while fetching data."));
    } finally {
      setLoading(false);
      toggleLoader(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);

useEffect(() => {
  let filtered = [...assetsData];

  // HR Users
  const Hrusermailids = userList
    ?.filter((item) => item?.roleid?.[0] === "4")
    ?.map((item) => item?.userid);

  const isHRUser = Hrusermailids?.includes(userInfo?.userid);

  // Reporting Manager Check
  const isReportingManager = assetsData
    .filter((incident) => incident?.departmentType === "Supervisory")
    .some((incident) => {
      const incidentUser = userList?.find(
        (item) => item?.userid === incident?.userId
      );

      return incidentUser?.reportingmanager === userInfo?.userid;
    });

  console.log({
    isITOnlyUser,
    isReportingManager,
    isHRUser,
  });

  // -------------------------
  // Permission Logic
  // -------------------------

  if (isITOnlyUser) {
    filtered = filtered.filter(
      (incident) => incident?.departmentType === "IT"
    );
  } else if (isReportingManager) {
    filtered = filtered.filter((incident) => {
      if (incident?.departmentType !== "Supervisory") return false;

      const incidentUser = userList?.find(
        (item) => item?.userid === incident?.userId
      );

      return incidentUser?.reportingmanager === userInfo?.userid;
    });
  } else if (!isHRUser) {
    // Not IT, Not Manager, Not HR
    setFilteredData([]);
    return;
  }

  // -------------------------
  // Common Filters
  // -------------------------

  if (searchText) {
    filtered = filtered.filter((incident) =>
      incident?.incidentlocation
        ?.toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }

  if (selectedType) {
    filtered = filtered.filter(
      (incident) =>
        incident?.type?.trim().toLowerCase() ===
        selectedType.toLowerCase()
    );
  }

  if (selectedStatus) {
    filtered = filtered.filter(
      (incident) =>
        incident?.status?.trim().toLowerCase() ===
        selectedStatus.toLowerCase()
    );
  }

  let startDate;
  let endDate;

  if (selectedDateRange === "Last week") {
    startDate = moment().subtract(1, "weeks").startOf("week");
    endDate = moment().subtract(1, "weeks").endOf("week");
  } else if (selectedDateRange === "Last month") {
    startDate = moment().subtract(1, "months").startOf("month");
    endDate = moment().subtract(1, "months").endOf("month");
  } else if (selectedDateRange === "Last 6 months") {
    startDate = moment().subtract(6, "months").startOf("month");
    endDate = moment().endOf("month");
  } else if (
    selectedDateRange === "custom" &&
    fromDate &&
    toDate
  ) {
    startDate = moment(fromDate).startOf("day");
    endDate = moment(toDate).endOf("day");
  }

  if (startDate && endDate) {
    filtered = filtered.filter((incident) =>
      moment(incident.date).isBetween(startDate, endDate, null, "[]")
    );
  }

  setFilteredData(filtered);
}, [
  searchText,
  selectedType,
  selectedStatus,
  selectedDateRange,
  fromDate,
  toDate,
  assetsData,
  isITOnlyUser,
  userList,
  userInfo,
]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "custom") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const columns = [
    {
      title: t("Incident ID"),
      dataIndex: "incidentId",
      key: "incidentId",
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Employee ID"),
      dataIndex: "employeeId",
      key: "employeeId",
    },
    {
      title: t("Incident Type"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: t("Date"),
      dataIndex: "date",
      key: "date",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
    {
      title: t("Time"),
      dataIndex: "time",
      key: "time",
      render: (text) => (text ? moment(text, "HH:mm").format("hh:mm A") : "-"),
    },
    {
      title: t("Location"),
      dataIndex: "incidentlocation",
      key: "incidentlocation",
      render: (text) =>
        text
          ? text
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
          : "",
    },
    {
      title: t("Reported on"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
  ];

  const incidentTypes = [
    { id: 1, label: "Asset Breakages", value: "Asset Breakages" },
    { id: 2, label: "Hardware Issues", value: "Hardware Issues" },
    { id: 3, label: "Software Issues", value: "Software Issues" },
    { id: 4, label: "System Problems", value: "System Problems" },
    { id: 5, label: "Application Problems", value: "Application Problems" },
    { id: 6, label: "Equipment Malfunctions", value: "Equipment Malfunctions" },
    {
      id: 7,
      label: "Other Technology-Related Incidents",
      value: "Other Technology-Related Incidents",
    },

    { id: 8, label: "Employee Relations", value: "Employee Relations" },
    { id: 9, label: "Attendance Matters", value: "Attendance Matters" },
    { id: 10, label: "Leave Matters", value: "Leave Matters" },
    { id: 11, label: "Workplace Conduct", value: "Workplace Conduct" },
    { id: 12, label: "Policy-Related Issues", value: "Policy-Related Issues" },
    { id: 13, label: "Grievances", value: "Grievances" },
    {
      id: 14,
      label: "Other Human Resource-Related Incidents",
      value: "Other Human Resource-Related Incidents",
    },

    { id: 15, label: "Workplace Accidents", value: "Workplace Accidents" },
    { id: 16, label: "Workplace Injuries", value: "Workplace Injuries" },
    { id: 17, label: "Unsafe Conditions", value: "Unsafe Conditions" },
    { id: 18, label: "Health Hazards", value: "Health Hazards" },
    { id: 19, label: "Safety Hazards", value: "Safety Hazards" },
    { id: 20, label: "Near-Miss Incidents", value: "Near-Miss Incidents" },
    {
      id: 21,
      label: "Other Occupational Safety Incidents",
      value: "Other Occupational Safety Incidents",
    },

    { id: 22, label: "Operational Issues", value: "Operational Issues" },
    {
      id: 23,
      label: "Work Performance Concerns",
      value: "Work Performance Concerns",
    },
    { id: 24, label: "Process Issues", value: "Process Issues" },
    { id: 25, label: "Workflow Issues", value: "Workflow Issues" },
    { id: 26, label: "Team-Related Matters", value: "Team-Related Matters" },
    {
      id: 27,
      label: "Supervisor Intervention Required",
      value: "Supervisor Intervention Required",
    },
    {
      id: 28,
      label: "Other Supervisory Incidents",
      value: "Other Supervisory Incidents",
    },
  ];

  // Only show IT-related categories in the dropdown for the restricted user.
  const visibleIncidentTypes = isITOnlyUser
    ? incidentTypes.filter((incident) =>
        IT_INCIDENT_TYPES.includes(incident.value)
      )
    : incidentTypes;

  return (
    <CustomStyle>
      <p style={{ fontWeight: 500, fontSize: 20 }}>{t("Incident Log")}</p>

      <div className="totaldropdowns">
        <Row gutter={16}>
          <Col>
            <div>
              <Input
                className="search"
                placeholder={t("Search Location")}
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select
                placeholder={t("Incident Type")}
                className="action-dropdown"
                allowClear
                onChange={setSelectedType}
                options={visibleIncidentTypes.map((incident) => ({
                  value: incident.value,
                  label: t(incident.label),
                }))}
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select
                placeholder={t("Date")}
                className="action-dropdown"
                onChange={handleSelectChange}
                allowClear
              >
                <Select.Option value="Last week">
                  {t("Last week")}
                </Select.Option>
                <Select.Option value="Last month">
                  {t("Last month")}
                </Select.Option>
                <Select.Option value="Last 6 months">
                  {t("Last 6 months")}
                </Select.Option>
                <Select.Option value="custom">
                  {t("Custom Date range")}
                </Select.Option>
              </Select>
            </div>
          </Col>
          {showDateRange && (
            <div className="date-range-container">
              <Col>
                <div>
                  <DatePicker
                    placeholder={t("From")}
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    onChange={(date) => {
                      setFromDate(date);
                      if (toDate && date && toDate.isBefore(date, "day")) {
                        setToDate(null);
                      }
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <DatePicker
                    placeholder={t("To")}
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    disabledDate={disableToDate}
                    onChange={(date) => setToDate(date)}
                  />
                </div>
              </Col>
            </div>
          )}
          <Col
            className={`dropdown-container ${
              showDateRange ? "adjust-margin" : ""
            }`}
          >
            <div className="dropdown-container">
              <Select
                placeholder={t("Status")}
                className="action-dropdown"
                onChange={handleStatusChange}
                allowClear
              >
                <Select.Option value="Waiting for Review">
                  {t("Waiting for Review")}
                </Select.Option>
                <Select.Option value="Under Review">
                  {t("Under Review")}
                </Select.Option>
                <Select.Option value="Resolved">{t("Resolved")}</Select.Option>
                <Select.Option value="Dismissed">
                  {t("Dismissed")}
                </Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      <p style={{ fontWeight: 400, fontSize: 16 }}>
        {t("Total Incident:")} &nbsp;{filteredData.length}
      </p>
      <Spin spinning={loading} size="medium">
        <Table
          dataSource={filteredData}
          columns={columns}
          pagination={true}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push({
                  pathname: `/viewincidentlog/${record.incidentId}`,
                  state: { incidentData: record },
                });
              },
            };
          }}
          scroll={{ x: "max-content" }}
          style={{ cursor: "pointer" }}
        />
      </Spin>
    </CustomStyle>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps)(IncidentLog);